import { AuthService } from '@/api/auth-service';
import BaseApiService from '@/api/base-api-service';

// TODO it's better not to use auth tokens in the browser.
export default class BaseAuthApiService extends BaseApiService {
  constructor(protected readonly authService: AuthService) {
    super();
  }

  public async authorizedRequest(url: string, options: RequestInit): Promise<Response> {
    return fetch(url, {
      ...options,
      headers: {
        ...this.headers,
        ...options.headers,
        Authorization: `Bearer ${this.authService.auth?.access}`,
      },
    });
  }
}
